import React from 'react'

export const GrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.5625 10.8701H19.7708C19.1725 10.8701 18.6875 11.3551 18.6875 11.9535V24.4118C18.6875 25.0101 19.1725 25.4951 19.7708 25.4951H23.5625C24.1608 25.4951 24.6458 25.0101 24.6458 24.4118V11.9535C24.6458 11.3551 24.1608 10.8701 23.5625 10.8701Z"
      fill="#F57606"
    />
    <path
      d="M14.8965 15.2035H11.1048C10.5065 15.2035 10.0215 15.6885 10.0215 16.2868V24.4118C10.0215 25.0101 10.5065 25.4952 11.1048 25.4952H14.8965C15.4948 25.4952 15.9798 25.0101 15.9798 24.4118V16.2868C15.9798 15.6885 15.4948 15.2035 14.8965 15.2035Z"
      fill="#F57606"
    />
    <path
      d="M6.22949 17.3701H2.43783C1.83952 17.3701 1.35449 17.8551 1.35449 18.4535V24.4118C1.35449 25.0101 1.83952 25.4951 2.43783 25.4951H6.22949C6.8278 25.4951 7.31283 25.0101 7.31283 24.4118V18.4535C7.31283 17.8551 6.8278 17.3701 6.22949 17.3701Z"
      fill="#F57606"
    />
    <path
      d="M3.24999 16.016C2.99348 16.0129 2.74639 15.9189 2.5527 15.7507C2.35901 15.5824 2.23129 15.351 2.19229 15.0974C2.15328 14.8439 2.20551 14.5847 2.33969 14.3661C2.47386 14.1474 2.68127 13.9835 2.92499 13.9035C6.24761 12.8521 9.44176 11.4313 12.4475 9.66762C15.9318 7.61943 19.1362 5.12873 21.9808 2.25762C22.0812 2.15525 22.2008 2.07382 22.3328 2.01803C22.4649 1.96224 22.6067 1.93321 22.75 1.93262C23.0342 1.93381 23.3065 2.04664 23.5083 2.24678C23.7101 2.44976 23.8234 2.72433 23.8234 3.01053C23.8234 3.29674 23.7101 3.57131 23.5083 3.77428C20.5375 6.78225 17.1871 9.38981 13.5417 11.531C10.3995 13.3977 7.05598 14.9023 3.57499 16.016C3.46727 16.0323 3.35771 16.0323 3.24999 16.016Z"
      fill="#F57606"
    />
    <path
      d="M22.7507 8.43262C22.4633 8.43262 22.1878 8.31848 21.9846 8.11532C21.7815 7.91215 21.6673 7.6366 21.6673 7.34928V4.09928H18.4173C18.13 4.09928 17.8544 3.98515 17.6513 3.78198C17.4481 3.57882 17.334 3.30327 17.334 3.01595C17.334 2.72863 17.4481 2.45308 17.6513 2.24992C17.8544 2.04675 18.13 1.93262 18.4173 1.93262H22.7507C23.038 1.93262 23.3135 2.04675 23.5167 2.24992C23.7198 2.45308 23.834 2.72863 23.834 3.01595V7.34928C23.834 7.6366 23.7198 7.91215 23.5167 8.11532C23.3135 8.31848 23.038 8.43262 22.7507 8.43262Z"
      fill="#F57606"
    />
  </svg>
)
